module.exports = __webpack_public_path__ + "img/qsy-banner.4ed29870.webp";